export default __webpack_public_path__ + "static/media/pt-girl.f75b1394.webp";